module.exports = __webpack_public_path__ + "img/6.acd14240.jpg";